
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"37.508","height":"51.77"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"パス 67","d":"M18.757 51.77a3.533 3.533 0 01-3.034-1.716 2567.432 2567.432 0 00-6.188-10.246C1.086 25.872-.001 24.081-.001 18.753a18.754 18.754 0 0137.508 0c0 6.239-1.828 8.674-7.887 16.743l-.724.967a3.535 3.535 0 01-5.656-4.243l.726-.969c5.923-7.888 6.471-8.726 6.471-12.5a11.684 11.684 0 00-23.369 0c0 3.2.4 4.008 8.512 17.389 1.723 2.843 3.771 6.22 6.2 10.274a3.535 3.535 0 01-3.028 5.354z","fill":"#12b6d4"}}),_c('path',{attrs:{"data-name":"パス 68","d":"M18.754 23.783a4.66 4.66 0 114.66-4.66 4.666 4.666 0 01-4.66 4.66z","fill":"#95bb00"}})])
          )
        }
      }
    